import * as type from "../types";

const initialState = {
  activeList: [],
  suspendedList: [],
  canceledList: [],
  k1RedemptionUsable: [],
  filterStation: null,
  filterResourceType: "-",
  filterProductionPeriodMonth: "",
  filterProductionPeriodYear: "",
  filterExportStartDateMonth: "",
  filterExportEndDateMonth: "",
  filterExportStartDateYear: "",
  filterExportEndDateYear: "",

  loading: false,
  error: false,
  documentCount: {
    totalCount: 0,
    countInPage: 0,
  },
  blockedDocumentCount: {
    totalCount: 0,
    countInPage: 0,
  },
  totalPageCount: 0,
  totalItemCount: 0,
};

export default function certificates(state = initialState, action) {
  switch (action.type) {
    case type.GET_ACTIVE_CERTIFICATES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_ACTIVE_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        activeList: action.payload.items,
        documentCount: {
          totalCount: action.payload.documentCount.totalCount,
          countInPage: action.payload.documentCount.countInPage,
        },
        blockedDocumentCount: {
          totalCount: action.payload.blockedDocumentCount.totalCount,
          countInPage: action.payload.blockedDocumentCount.countInPage,
        },
        totalPageCount: action.payload.totalPageCount,
        totalItemCount: action.payload.totalItemCount,
        loading: false,
        error: false,
      };
    case type.GET_ACTIVE_CERTIFICATES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_SUSPENDED_CERTIFICATES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_SUSPENDED_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        suspendedList: action.payload.items,
        total: action.payload.total,
        documentCount: {
          countInPage: action.payload.documentCount.countInPage,
          totalCount: action.payload.documentCount.totalCount,
        },
        blockedDocumentCount: {
          countInPage: action.payload.blockedDocumentCount.countInPage,
          totalCount: action.payload.blockedDocumentCount.totalCount,
        },
        loading: false,
        error: false,
      };
    case type.GET_SUSPENDED_CERTIFICATES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_CANCELED_CERTIFICATES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_CANCELED_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        canceledList: action.payload.items,
        total: action.payload.total,
        documentCount: {
          countInPage: action.payload.documentCount.countInPage,
          totalCount: action.payload.documentCount.totalCount,
        },
        blockedDocumentCount: {
          countInPage: action.payload.blockedDocumentCount.countInPage,
          totalCount: action.payload.blockedDocumentCount.totalCount,
        },
        loading: false,
        error: false,
      };
    case type.GET_CANCELED_CERTIFICATES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_REDEMPTION_USABLE_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        k1RedemptionUsable: action.payload,
        k1RedemptionUsableDocumentCount: {
          countInPage: action.payload.documentCount.countInPage,
          totalCount: action.payload.documentCount.totalCount,
        },
        k1RedemptionUsableBlockedDocumentCount: {
          countInPage: action.payload.blockedDocumentCount.countInPage,
          totalCount: action.payload.blockedDocumentCount.totalCount,
        },
        loading: false,
        error: false,
      };
    case type.GET_REDEMPTION_USABLE_CERTIFICATES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.SET_CERTIFICATE_FILTER_STATION:
      return {
        ...state,
        filterStation: action.payload,
      };
    case type.SET_CERTIFICATE_FILTER_RESOURCE_TYPE:
      return {
        ...state,
        filterResourceType: action.payload,
      };
    case type.SET_CERTIFICATE_FILTER_PRODUCTION_PERIOD:
      return {
        ...state,
        filterProductionPeriodMonth: action.payload.month,
        filterProductionPeriodYear: action.payload.year,
      };
    case type.SET_CERTIFICATE_FILTER_EXPORT_START_DATE:
      return {
        ...state,
        filterExportStartDateMonth: action.payload.month,
        filterExportStartDateYear: action.payload.year,
      };
    case type.SET_CERTIFICATE_FILTER_EXPORT_END_DATE:
      return {
        ...state,
        filterExportEndDateMonth: action.payload.month,
        filterExportEndDateYear: action.payload.year,
      };
    default:
      return state;
  }
}
